/* eslint-disable @typescript-eslint/camelcase */
import { QueryParamsEntities } from "@/domain/entities/MainApp";
import { EditUserRequestInterface } from "../contracts/UserRequest";
import { ConvertObjectCamelToSnakeCase } from "@/app/infrastructures/misc/Utils";

export class EditUserApiRequest implements EditUserRequestInterface {
  account_id = 0;
  status = "";
  email = "";
  assigned_3lc = "";
  hub_id = 0;
  division_id = 0;
  shuttle_id = 0;

  constructor(fields?: Partial<EditUserApiRequest>) {
    Object.assign(this, fields);
  }

  public toJSON() {
    const account_id = this.account_id;
    const status = this.status;
    const email = this.email;
    const assigned_3lc = this.assigned_3lc;
    const hub_id = this.hub_id;
    const division_id = this.division_id;
    const shuttle_id = this.shuttle_id
    const payload = {
      account_id,
      status,
      assigned_3lc,
      hub_id,
      division_id,
      shuttle_id
    };
    if (email) {
      Object.assign(payload, {
        email
      });
    }
    return JSON.stringify(payload);
  }
}

export class AddUserApiRequest {
  username = "";
  email = "";
  phone_number = "";
  account_type = "";
  role_id = 0;
  reference_id = 0;
  assigned_3lc = "";
  hub_id = 0;
  division_id = 0;
  shuttle_id = 0;
  hq_country = "";

  constructor(fields?: Partial<AddUserApiRequest>
  ) {
    Object.assign(this, fields);
  }

  get isTypeConsole() {
    return this.account_type.match(/^console$/);
  }

  get isTypeInternal() {
    return this.account_type.match(/^internal$/);
  }

  public toJSON() {
    const username = this.username;
    const email = this.email;
    const phone_number = this.phone_number;
    const account_type = this.account_type;
    const role_id = this.role_id;
    const reference_id = this.reference_id;
    const assigned_3lc = this.assigned_3lc;
    const hub_id = this.hub_id || 0;
    const division_id = this.division_id;
    const shuttle_id = this.shuttle_id;
    const hq_country = this.hq_country;

    const payload = {
      username,
      email,
      phone_number,
      account_type,
      role_id,
      reference_id,
      assigned_3lc,
      division_id,
      shuttle_id
    } as any

    if (this.isTypeConsole) payload.hub_id = hub_id;
    if (this.isTypeInternal) payload.hq_country = hq_country;

    return JSON.stringify(payload);
  }
}

export class RequestListUser {
  [x: string]: any;
  page = 1;
  limit = 10;
  account_type = "";
  reference = "";
  status = "";
  isTotalData = false;
  search = "";
  version = "1";
  accountType = "";
  hub_id = 0;
  division_id = 0;
  hub_ids = "";

  constructor(fields?: Partial<RequestListUser>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class EditRoleApiRequest implements EditUserRequestInterface {
  accountId = 0;
  roleId = 0;
  status = "";
  assigned_3lc = "";
  constructor(fields?: Partial<EditRoleApiRequest>) {
    Object.assign(this, fields);
  }

  toJSON(): string {
    return JSON.stringify(ConvertObjectCamelToSnakeCase(this));
  }
}

export class EditAssigned3lcApiRequest implements EditUserRequestInterface {
  accountId = 0;
  assigned_3lc = "";
  status = "";
  constructor(fields?: Partial<EditAssigned3lcApiRequest>) {
    Object.assign(this, fields);
  }

  toJSON(): string {
    return JSON.stringify(ConvertObjectCamelToSnakeCase(this));
  }
}
